module.exports = __webpack_public_path__ + "img/community06.19586a68.png";